"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Context = exports.BucketingMethod = void 0;
const CONTEXT_PREFIX = 'context.';
const ENV_PREFIX = 'env.';
var BucketingMethod;
(function (BucketingMethod) {
    BucketingMethod["Legacy"] = "legacy";
    BucketingMethod["Universal"] = "universal";
})(BucketingMethod = exports.BucketingMethod || (exports.BucketingMethod = {}));
class Context {
    constructor(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    interpreterEnv, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    interpreterContext, dynamicValueName, errorHandler, bucketingMethod = BucketingMethod.Legacy) {
        this.interpreterEnv = interpreterEnv;
        this.interpreterContext = interpreterContext;
        this.bucketingMethod = bucketingMethod;
        this.dynamicValueName = dynamicValueName;
        this.errorHandler = errorHandler;
        this.resolutionDetails = {};
    }
    // Returns the value for the properyKey parameter. If there is a
    // .context prefix, it is removed before being used as a key.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getProperty(key) {
        if (key.startsWith(CONTEXT_PREFIX)) {
            return this.interpreterContext[key.replace(CONTEXT_PREFIX, '')];
        }
        if (key.startsWith(ENV_PREFIX)) {
            return this.interpreterEnv[key.replace(ENV_PREFIX, '')];
        }
        this.addResolutionLog(`WARNING: Property ${key} accessed without context or env prefix.`);
        return this.interpreterContext[key] || this.interpreterEnv[key];
    }
    getDynamicValueName() {
        return this.dynamicValueName;
    }
    sendError(e) {
        this.errorHandler(e);
    }
    /**
     * Get all tracking and resolution details logged into this Context
     */
    getResolutionDetails() {
        return this.resolutionDetails;
    }
    /**
     * Add partial resolution details to this context.
     *
     * Eg, { identifier: ..., identifierType: ... }
     *
     * To append to the resolution log, use `addResolutionLog` instead.
     *
     * @param details Partial<TrackingData> resolution details to add.
     */
    addResolutionDetails(details) {
        this.resolutionDetails = {
            ...this.resolutionDetails,
            ...details,
        };
    }
    /**
     * Append a log line to the resolution log for this context.
     *
     * The resolution log will be undefined until a log line has been added.
     *
     * @param log The log line to add.
     */
    addResolutionLog(log) {
        if (!this.resolutionDetails.resolution_log) {
            this.resolutionDetails.resolution_log = [];
        }
        this.resolutionDetails.resolution_log.push(log);
    }
}
exports.Context = Context;
//# sourceMappingURL=context.js.map